// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3737":"4d5d69f535e27b96","5981":"f7cf76e852e533ad"}[chunkId] + ".css";
};